export const initMapScript = () => {
  function initMap() {
      // position we will use later
      var lat = 50.809019;
      var lon = 16.280549;

      var lat2 = 50.805139;
      var lon2 = 16.281411;
      // initialize map
      var map = L.map('map-here', {
    center: [lat, lon],
    zoom: 15,
    scrollWheelZoom: false,
    zoomControl: true
  });
      // set map tiles source
      L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/light-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYmFyYW5pYWtsIiwiYSI6ImNqcGwzd2NtYzA3ZnUzeHJwbmlqdDIydGMifQ.9LcFH_UwDWHovj83jn_h0w', {
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 20,
      }).addTo(map);
      // add marker to the map
    
      let marker2 = L.marker([lat2, lon2]).addTo(map);
      // add popup to the marker
      marker2.bindPopup('<b>Drukarnia</b><br>Broniewskiego 2a,<br>58-309 Wałbrzych').openPopup();

      let marker = L.marker([lat, lon]).addTo(map);
      // add popup to the marker
      marker.bindPopup('<b>Sklep firmowy</b><br>Broniewskiego 65c,<br>58-309 Wałbrzych').openPopup();

  }
  initMap();
}